import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9769f91c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "send__title" }, "Send", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import SelectAccountInput from "@/components/select-account-input/index.vue";
import SearchAccountInput from "@/components/search-account-input/index.vue";
import AmountInput from "@/components/amount-input/index.vue";
import FeeInfo from "@/components/fee-info/index.vue";
import ButtonsBlock from "@/components/buttons-block/index.vue";
import BaseButton from "@/components/base-button/index.vue";
import SendError from "./components/send-error.vue";
import {
  accounts,
  apiPromise,
  nativeBalances,
  nativeToken,
  selectedNetwork,
} from "@/stores";
import { Account } from "@/types/account";
import { Token } from "@/types/token";
import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useGetAccountNativeBalance } from "@/libs/balances";
import { useGetNativePrice } from "@/libs/prices";
import { isValidDecimals, toBase } from "@/utils/units";
import { GasFeeInfo } from "@/types/transaction";
import { sendExtrinsic } from "@/utils/extrinsic";
import { toBN } from "web3-utils";
import { getGasFeeInfo } from "@/utils/fee";
import AccountsState from "@/state/accounts";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const accountsState = new AccountsState();

const fromAccount = ref<Account>(accounts.value[0]);
const toAccount = ref<Account>();
const amount = ref<string>("");
const fee = ref<GasFeeInfo>();
const selectedAsset = ref<Token>(nativeToken.value);
const hasEnough = ref(true);
const recentAccounts = ref<Account[]>([]);

const isValid = computed<boolean>(() => {
  return (
    !!fromAccount.value &&
    !!toAccount.value &&
    Number(amount.value) > 0 &&
    hasEnough.value
  );
});

watch(fromAccount, () => {
  if (fromAccount.value) {
    useGetAccountNativeBalance(fromAccount.value.address);
    useGetNativePrice();
  }
});

watch(selectedNetwork, () => {
  selectedAsset.value = nativeToken.value;
});

onMounted(async () => {
  if (route.query.from) {
    const found = accounts.value.find(
      (item) => item.address === route.query.from
    );
    if (found) {
      fromAccount.value = found;
    }
  }
  if (route.query.to) {
    const found = accounts.value.find(
      (item) => item.address === route.query.to
    );
    if (found) {
      toAccount.value = found;
    }
  }
  if (route.query.amount) {
    const converted = Number(route.query.amount);
    if (converted) {
      amount.value = converted.toString();
    }
  }

  recentAccounts.value = await accountsState.getRecentAccounts();
  loadFeeInfo();
  validateInputs();
});

const edWarn = computed(() => {
  if (!fee.value || !amount.value) {
    return false;
  }

  if (!isValidDecimals(amount.value, selectedAsset.value.decimals)) {
    return false;
  }

  const rawAmount = toBN(
    toBase(amount.value?.toString() || "0", selectedAsset.value.decimals)
  );
  const ed = toBN(
    toBase(
      selectedAsset.value.existentialDeposit.toString() || "0",
      selectedAsset.value.decimals
    )
  );
  const userBalance = toBN(
    toBase(
      nativeBalances[fromAccount.value.address]?.available.toString() || "0",
      selectedAsset.value.decimals
    )
  );

  const txFee = toBN(
    toBase(fee.value.nativeValue.toString(), selectedAsset.value.decimals)
  );
  return userBalance.sub(txFee).sub(rawAmount).lt(ed);
});

const selectFromAccount = (account: Account) => {
  fromAccount.value = account;
};

const selectToAccount = (account: Account) => {
  toAccount.value = account;
};

const inputAmount = (newVal: string) => {
  amount.value = newVal;
};

const nextAction = () => {
  router.push({
    name: "send-verify",
    query: {
      from: fromAccount.value.address,
      to: toAccount.value?.address,
      amount: amount.value,
    },
  });
};

const validateInputs = async () => {
  if (
    amount.value &&
    selectedAsset.value &&
    fromAccount.value &&
    toAccount.value
  ) {
    if (
      !isValidDecimals(amount.value.toString(), selectedAsset.value.decimals)
    ) {
      hasEnough.value = false;
      return;
    }

    const rawAmount = toBN(
      toBase(amount.value?.toString() || "0", selectedAsset.value.decimals)
    );

    const rawBalance = toBN(
      toBase(
        nativeBalances[fromAccount.value.address]?.available.toString() || "0",
        selectedAsset.value.decimals
      )
    );

    if (rawAmount.gt(rawBalance)) {
      hasEnough.value = false;
    } else {
      hasEnough.value = true;
    }
  }
};

const loadFeeInfo = async () => {
  // Load fee info for transaction with mock values
  const api = await apiPromise.value;

  const tx = await sendExtrinsic(
    api,
    accounts.value[0].address,
    "1",
    "transfer"
  );

  fee.value = await getGasFeeInfo(tx, fromAccount.value.address);
};

watch(
  [
    selectedAsset,
    amount,
    nativeBalances,
    fromAccount,
    toAccount,
    selectedNetwork,
  ],
  validateInputs
);

watch([selectedNetwork, accounts], loadFeeInfo);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WhiteWrapper, { class: "send__wrap" }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_unref(accounts).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(SelectAccountInput, {
              account: fromAccount.value,
              accounts: _unref(accounts),
              "is-amount": true,
              token: _unref(nativeToken),
              title: "From",
              "onUpdate:select": selectFromAccount
            }, null, 8, ["account", "accounts", "token"]),
            _createVNode(SearchAccountInput, {
              account: toAccount.value,
              accounts: _unref(accounts),
              recent: recentAccounts.value,
              "onUpdate:select": selectToAccount
            }, null, 8, ["account", "accounts", "recent"]),
            _createVNode(AmountInput, {
              "has-enough-balance": hasEnough.value,
              token: selectedAsset.value,
              value: amount.value,
              "max-value": _unref(nativeBalances)[fromAccount.value?.address]?.available,
              "onUpdate:amount": inputAmount
            }, null, 8, ["has-enough-balance", "token", "value", "max-value"]),
            _createVNode(FeeInfo, { fee: fee.value }, null, 8, ["fee"]),
            (edWarn.value)
              ? (_openBlock(), _createBlock(SendError, {
                  key: 0,
                  token: selectedAsset.value
                }, null, 8, ["token"]))
              : _createCommentVNode("", true),
            _createVNode(ButtonsBlock, null, {
              default: _withCtx(() => [
                _createVNode(BaseButton, {
                  title: "Continue",
                  action: nextAction,
                  send: true,
                  disabled: !isValid.value
                }, null, 8, ["disabled"])
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, "Please connect your wallet so you can send tokens."))
    ]),
    _: 1
  }))
}
}

})